export default __webpack_public_path__ + "static/media/I.6bb1e5d8.svg";